var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridItem = void 0;
var GridItem_1 = __importDefault(require("./GridItem"));
exports.GridItem = GridItem_1.default;
exports.default = GridItem_1.default;
//# sourceMappingURL=index.js.map